import { get, post, destroy } from 'utils/fetchRequest';

export const getFeedbackList = async (searchText) => {
    try {
        const result = await get(`feedbacks${searchText ? `?search=${searchText}` : ''}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const createFeedback = async (data) => {
    try {
        const result = await post('feedbacks', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const deleteFeedback = async (id) => {
    try {
        const result = await destroy(`feedbacks/${id}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};
